'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
// Autogenerated by Thrift Compiler (0.9.3-airbnb12)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//
var PropTypes = process.env.NODE_ENV === 'production' ? null : require('prop-types');
var logging_context_v2 = process.env.NODE_ENV === 'production' ? {} : require('./logging_context_v2');
var logging_type_native_measurement_v1 = process.env.NODE_ENV === 'production' ? {} : require('./logging_type_native_measurement_v1');
var logging_type_native_mode_type_v1 = process.env.NODE_ENV === 'production' ? {} : require('./logging_type_native_mode_type_v1');
var logging_type_page_name_v1 = process.env.NODE_ENV === 'production' ? {} : require('./logging_type_page_name_v1');
var logging_type_loading_step_performance_v1 = process.env.NODE_ENV === 'production' ? {} : require('./logging_type_loading_step_performance_v1');

var NativeMeasurementEvent = exports.NativeMeasurementEvent = {
  defaultProps: {
    schema: 'com.airbnb.jitney.event.logging.Performance:NativeMeasurementEvent:2.0.0',
    event_name: 'native_measurement'
  },
  propTypes: process.env.NODE_ENV === 'production' ? {} : {
    schema: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    event_name: process.env.NODE_ENV === 'production' ? {} : PropTypes.string.isRequired,
    context: process.env.NODE_ENV === 'production' ? {} : PropTypes.shape(logging_context_v2.Context.propTypes).isRequired,
    measurement_type: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOf(Object.values(logging_type_native_measurement_v1.NativeMeasurementType)).isRequired,
    native_measurement_operation: process.env.NODE_ENV === 'production' ? {} : PropTypes.string.isRequired,
    value: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    app_mode: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOf(Object.values(logging_type_native_mode_type_v1.NativeModeType)).isRequired,
    view: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    information: process.env.NODE_ENV === 'production' ? {} : PropTypes.objectOf(PropTypes.string),
    universal_page_name: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOf(Object.values(logging_type_page_name_v1.PageName)),
    event_data: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    event_data_schema: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    steps_performance: process.env.NODE_ENV === 'production' ? {} : PropTypes.arrayOf(PropTypes.shape(logging_type_loading_step_performance_v1.LoadingStepPerformance.propTypes)),
    tti_status: process.env.NODE_ENV === 'production' ? {} : PropTypes.string
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-jitney-schemas/logging_performance_native_measurement_v2.js
// module id = 458
// module chunks = 168707334958949